/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from 'underscore';
import React, { useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Link } from '@bingads-webui-react/fabric-with-signal';

import { FAQAccordion } from './faq-accordion';
import { getFaqSectionStyles } from './styles/get-faq-section-styles';

export function FAQSection(props) {
  const {
    faqArray,
    faqArrayLengthLimit,
    logger,
  } = props;
  const classes = useDefaultStyles(getFaqSectionStyles);
  const i18n = useContext(I18nContext);
  const [isShowMoreLink, setIsShowMoreLink] = useState(_.isNumber(faqArrayLengthLimit) ? faqArray.length > faqArrayLengthLimit : false);
  const [showingFaqArray, setShowingFaqArray] = useState(_.isNumber(faqArrayLengthLimit) ? faqArray.slice(0, faqArrayLengthLimit) : faqArray);

  const onClickShowMoreFaq = useCallback(() => {
    logger.trace('click see more questions link');
    setIsShowMoreLink(false);
    setShowingFaqArray(faqArray);
  }, [faqArray, logger]);

  return (
    <div className={classNames('faq-container', classes.faqContainer)}>
      <div className={classNames('faq-inner-container', classes.faqInnerContainer)}>
        <div className={classNames('faq-header', classes.faqHeader)}>
          {i18n.getString(_TL_('FAQ'))}
        </div>
        <div className={classNames('faq-accordions-container', classes.faqAccordionsContainer)}>
          {showingFaqArray && showingFaqArray.map(faqItem => (
            <FAQAccordion
              title={faqItem.title}
              content={faqItem.content}
              key={faqItem.title}
              logger={logger}
            />
          ))}
          {
            isShowMoreLink &&
            <Link
              className={classNames('see-more-questions', classes.moreLink)}
              name="See more questions"
              onClick={onClickShowMoreFaq}
            >
              {i18n.getString(_TL_('See more questions'))}
            </Link>
          }
        </div>
      </div>
    </div>
  );
}

FAQSection.propTypes = {
  faqArray: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  })).isRequired,
  faqArrayLengthLimit: PropTypes.number,
  logger: PropTypes.shape({
    trace: PropTypes.func.isRequired,
  }),
};

FAQSection.defaultProps = {
  faqArrayLengthLimit: undefined,
  logger: {
    trace: _.noop,
  },
};
